<template>
    <div v-if="invalid == false" class="main_container">
      <h3>Loading...</h3>
      <p>Verifying your link...</p>
    </div>
    <div v-else class="main_container">
      <h3>Error</h3>
      <p>
        The link you followed is invalid or has expired. Please contact your
        representative for a new link.
      </p>
    </div>
  </template>
  <script>
  // import $ from "jquery";
  import MyUtils from "@/utils/MyUtils";

  export default {
    name: "AffiliatesLoading",
    components: {},
    props: {
      link: String,
    },
    data() {
      return {
        invalid: false,
      };
    },
    methods: {
      next() {
        this.$emit("setLoadingData", this.$data);
        this.$emit("next", this.$data);
        console.log(this.$data);
      },
      doubleNext() {
        this.$emit("doublenext", this.$data);
      },
    },
    mounted: function () {
    },
    created: function(){
      let self = this;
      let email = MyUtils.getWithExpiry('email');
      console.log('email storage:')
      console.log(email);
      self.invalid = false;
      self.next();      
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .main_container {
    padding-top: 64px;
    margin-left: 8%;
    margin-right: 8%;
    height: 70vh;
  }
  </style>
  